import styled from "@emotion/styled";

export const ButtonContainer = styled.div`
  display: flex;
`;
